import { createAsyncThunk } from '@reduxjs/toolkit'

import {
  WELLNESS_CHECK_IN_ENTRY_POINTS_TYPE,
  WellnessCheckInParsedResults,
  WellnessCheckInRequestData,
  WellnessCheckInResponse,
} from '@lyrahealth-inc/shared-app-logic'

import {
  getWellnessCheckInResults,
  postWellnessCheckInResults,
  postWellnessCheckInResultsV2,
  WellnessCheckInRequestV2Data,
} from '../../../common/http/data/wellnessCheckIn'

export const getWellnessCheckInResultsData = createAsyncThunk<WellnessCheckInResponse[], { lyraId: string }>(
  'GET_WELLNESS_CHECK_IN_RESULTS',
  async ({ lyraId }, { rejectWithValue }) => {
    try {
      const response = await getWellnessCheckInResults(lyraId)
      return response.data
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const postWellnessCheckInResultsData = createAsyncThunk<
  WellnessCheckInResponse,
  { lyraId: string; requestBody: WellnessCheckInRequestData }
>('POST_WELLNESS_CHECK_IN_RESULTS', async ({ lyraId, requestBody }, { rejectWithValue }) => {
  try {
    const response = await postWellnessCheckInResults(lyraId, requestBody)
    return response.data
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const postWellnessCheckInResultsDataV2 = createAsyncThunk<
  WellnessCheckInResponse,
  { lyraId: string; requestBody: WellnessCheckInRequestV2Data }
>('POST_WELLNESS_CHECK_IN_RESULTS_V2', async ({ lyraId, requestBody }, { rejectWithValue }) => {
  try {
    const response = await postWellnessCheckInResultsV2(lyraId, requestBody)
    return response.data
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const GET_WELLNESS_CHECK_IN_RESULTS_DATA_fulfilled = getWellnessCheckInResultsData.fulfilled.type
export const SET_WELLNESS_CHECK_IN_ENTRY_POINT = 'SET_WELLNESS_CHECK_IN_ENTRY_POINT'
export const CLEAR_WELLNESS_CHECK_IN_ENTRY_POINT = 'CLEAR_WELLNESS_CHECK_IN_ENTRY_POINT'
export const SET_WELLNESS_CHECK_IN_FORM_VALUES = 'SET_WELLNESS_CHECK_IN_FORM_VALUES'
export const CLEAR_WELLNESS_CHECK_IN_FORM_VALUES = 'CLEAR_WELLNESS_CHECK_IN_FORM_VALUES'
export const SET_WELLNESS_CHECK_IN_RESULTS = 'SET_WELLNESS_CHECK_IN_RESULTS'
export const CLEAR_WELLNESS_CHECK_IN_RESULTS = 'CLEAR_WELLNESS_CHECK_IN_RESULTS'
export const SET_SHOULD_SAVE_WELLNESS_CHECK_IN_POST_LOGIN = 'SET_SHOULD_SAVE_WELLNESS_CHECK_IN_POST_LOGIN'

export const setWellnessCheckInEntryPoint = (entryPoint: WELLNESS_CHECK_IN_ENTRY_POINTS_TYPE) => {
  return (dispatch: $TSFixMe) => {
    dispatch({
      type: SET_WELLNESS_CHECK_IN_ENTRY_POINT,
      data: entryPoint,
    })
  }
}

export const setWellnessCheckInFormValues = (values: object) => {
  return (dispatch: $TSFixMe) => {
    dispatch({
      type: SET_WELLNESS_CHECK_IN_FORM_VALUES,
      data: values,
    })
  }
}

export const clearWellnessCheckInFormValues = () => ({
  type: CLEAR_WELLNESS_CHECK_IN_FORM_VALUES,
})

export const setWellnessCheckInResults = (values: WellnessCheckInParsedResults) => {
  return (dispatch: $TSFixMe) => {
    dispatch({
      type: SET_WELLNESS_CHECK_IN_RESULTS,
      data: values,
    })
  }
}

export const setShouldSaveWellnessCheckInPostLogin = (shouldSave: boolean) => {
  return (dispatch: $TSFixMe) => {
    dispatch({
      type: SET_SHOULD_SAVE_WELLNESS_CHECK_IN_POST_LOGIN,
      data: shouldSave,
    })
  }
}

export const clearWellnessCheckInResults = () => ({
  type: CLEAR_WELLNESS_CHECK_IN_RESULTS,
})

export const clearWellnessCheckInEntryPoint = () => ({
  type: CLEAR_WELLNESS_CHECK_IN_ENTRY_POINT,
})
